import { render } from "./ShStatsPage.vue?vue&type=template&id=4e990916&scoped=true"
import script from "./ShStatsPage.vue?vue&type=script&lang=js"
export * from "./ShStatsPage.vue?vue&type=script&lang=js"

import "./ShStatsPage.vue?vue&type=style&index=0&id=4e990916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e990916"]])

export default __exports__